import icon from '../../assets/icons/title-highlight.png'
const Title = ({text}) => {

    return(
       <span className='relative text-purple bg-transparent z-0 '>
        {text}
        <img src={icon}
        className='absolute mt-1 -z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
        />
       </span>
    )
}
export default Title